import { radius, tokens } from "../styles/theme";

export function Skeleton({ height = 72, count = 3 }: { height?: number; count?: number }) {
  return (
    <div aria-hidden style={{ display: "grid", gap: "10px" }}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          style={{
            height,
            background: tokens.sunken,
            border: `1px solid ${tokens.line}`,
            borderRadius: radius.md,
            animation: "bd-skeleton-pulse 1.6s ease-in-out infinite",
          }}
        />
      ))}
    </div>
  );
}
